module.exports = __webpack_public_path__ + "img/certificate.34251d37.png";